<template>
    <app-layout>
        <div v-show="loaderAll" class="loaderAll"></div>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0"></div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Extrato
                </h2>
            </div>
        </template>

        <div class="pb-12">
            <flash :timeout="5000" />
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 pt-10">
                <div class="bg-white shadow-xl sm:rounded-lg px-4 py-4">
                    <div class="grid grid-cols-10 gap-6 mb-6">
                        <div class="col-span-8">
                            <h2
                                class="font-semibold text-xl text-gray-800 leading-tight mt-2"
                            >
                                Extrato de {{ $page.props.activeAccount.name }}
                            </h2>
                            <p
                                v-if="
                                    transactions.filter_interval.date_from !==
                                        null ||
                                        transactions.filter_interval.date_to !==
                                            null
                                "
                            >
                                {{
                                    transactions.filter_interval.date_from ||
                                        transactions.transactions_interval
                                            .date_from | smallDate
                                }}
                                a
                                {{
                                    transactions.filter_interval.date_to ||
                                        transactions.transactions_interval
                                            .date_to | smallDate
                                }}
                            </p>
                        </div>
                        <div class="col-span-2">
                            <balance :short="true" />
                        </div>
                    </div>
                    <div>
                        <button
                            class="text-xs items-center px-4 py-1 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150"
                            @click="downloadExtract('csv')"
                        >
                            <i class="fas fa-file-csv"></i>
                            Exportar CSV
                        </button>
                        <button
                            class="ttext-xs items-center px-4 py-1 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150"
                            @click="downloadExtract('pdf')"
                        >
                            <i class="fas fa-file-pdf"></i>
                            Exportar PDF
                        </button>
                        <button
                            class="ttext-xs items-center px-4 py-1 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150"
                            @click="downloadExtract('ofx')"
                        >
                            <i class="fas fa-file-archive"></i>
                            Exportar OFX
                        </button>
                    </div>

                    <div>
                        <inertia-table
                            :data="transactions"
                            :enable-display="true"
                            :params="params"
                            :columns="columns"
                            :filters="filters"
                            :enableExport="false"
                            id="id"
                            routeName="extract.index"
                            parent="extract"
                            @item-selected="show"
                        >
                            <template slot-scope="row" slot="date_brt">
                                {{ row.item.date_brt ? row.item.date_brt : row.item.created | smallDateTime }}
                            </template>
                            <template slot-scope="row" slot="nsu">
                                {{ row.item.nsu ? row.item.nsu : '-----' }}
                            </template>
                            <template
                                slot-scope="row"
                                slot="transaction_description"
                            >
                                <div
                                    v-html="row.item.description_formatted"
                                ></div>
                            </template>
                            <template
                                slot-scope="row"
                                slot="transaction_amount"
                            >
                                <div
                                    class="w-full text-right"
                                    v-bind:class="{
                                        'text-red-500':
                                            row.item.movement_type === 'D',
                                        'text-blue-500':
                                            row.item.movement_type === 'C',
                                        'text-gray-500 line-through':
                                            row.item.movement_type !== 'C' && row.item.movement_type !== 'D'
                                    }"
                                >
                                    {{
                                        row.item.movement_type === "D"
                                            ? "-"
                                            : ""
                                    }}{{ row.item.amount | currency }}
                                </div>
                            </template>
                            <template slot-scope="row" slot="balance">
                                <div class="w-full text-right text-blue-500">
                                    {{ row.item.balance | currency }}
                                </div>
                            </template>
                        </inertia-table>
                    </div>
                </div>
                <jet-dialog-modal
                    :closeable="false"
                    :show="showTransferTimedOutWarning"
                    @close="showTransferTimedOutWarning = false"
                >
                    <template #title>
                        Transferência em processamento
                    </template>

                    <template #content>
                        Transação em processamento, em alguns instantes poderá
                        ser visualizada em seu extrato.
                    </template>

                    <template #footer>
                        <jet-ok-button
                            class="ml-2"
                            @click.native="$inertia.visit('/extract')"
                        >
                            Confirmar
                        </jet-ok-button>
                    </template>
                </jet-dialog-modal>

                <jet-confirmation-modal
                    :show="showRollbackPixModal"
                    @close="showRollbackPixModal = false"
                >
                    <template #title>
                        Devolução de PIX
                    </template>
                    <template #content>
                        <template>
                            <div class="col">
                                Confirma a devolução de R$
                                {{
                                    formPixRollback.selectedTransaction.amount
                                        | currency
                                }}<br />recebidos via PIX?
                            </div>
                            <jet-section-border />
                            <jet-form-section>
                                <template #title>
                                    Autenticação
                                </template>

                                <template #description>
                                    Informe o código de autorização para
                                    autenticar sua solicitação
                                </template>

                                <template #form>
                                    <div class="col-span-6 sm:col-span-6">
                                        <jet-label
                                            for="google_code"
                                            value="Código de Autorização"
                                        />
                                        <jet-input
                                            id="google_code"
                                            type="number"
                                            class="mt-1 block w-full"
                                            v-model="
                                                formPixRollback.google_code
                                            "
                                        />
                                        <jet-input-error
                                            :message="
                                                formPixRollback.error(
                                                    'google_code'
                                                )
                                            "
                                            class="mt-2"
                                        />
                                    </div>
                                </template>
                            </jet-form-section>
                        </template>
                    </template>
                    <template #footer>
                        <jet-secondary-button
                            class="ml-2"
                            @click.native="showRollbackPixModal = false"
                        >
                            Cancelar
                        </jet-secondary-button>
                        <jet-ok-button
                            class="ml-2"
                            @click.native="requestPixRollback"
                        >
                            Confirmar
                        </jet-ok-button>
                    </template>
                </jet-confirmation-modal>
            </div>
        </div>
    </app-layout>
</template>
<script>
import AppLayout from "./../../Layouts/AppLayout";
import Welcome from "./../../Jetstream/Welcome";
import JetConfirmationModal from "./../../Jetstream/ConfirmationModal";
import JetSectionBorder from "./../../Jetstream/SectionBorder";
import JetFormSection from "../../Jetstream/FormSection";
import JetInputError from "../../Jetstream/InputError";
import JetLabel from "../../Jetstream/Label";
import JetSecondaryButton from "./../../Jetstream/SecondaryButton";
import JetOkButton from "./../../Jetstream/OkButton";
import ApplicationMark from "./../../Jetstream/ApplicationMark";
import JetDialogModal from "./../../Jetstream/DialogModal";
import JetInput from "../../Jetstream/Input";
import Flash from "../../Helpers/Flash";
import InertiaTable from "../../Helpers/Tables/InertiaTable";
import TransferReceipt from "../Transfer/Receipt";
import BoletoReceipt from "../Boleto/Receipt";
import Balance from "../../Helpers/Balance";

export default {
    components: {
        Balance,
        AppLayout,
        Flash,
        InertiaTable,
        TransferReceipt,
        JetSectionBorder,
        JetLabel,
        JetInput,
        JetInputError,
        JetFormSection,
        BoletoReceipt,
        Welcome,
        JetConfirmationModal,
        JetSecondaryButton,
        JetDialogModal,
        JetOkButton,
        ApplicationMark
    },
    props: ["transactions", "account", "errors", "transfer_timed_out"],
    data() {
        return {
            loaderAll: false,
            showRollbackPixModal: false,
            showTransferTimedOutWarning: this.transfer_timed_out,
            accountTypes: {
                1: "Corrente",
                2: "Poupança",
                3: "Pagamento"
            },
            columns: [
                {
                    text: "Data",
                    className: "text-left",
                    key: "date_brt",
                    sortable: true
                },
                {
                    text: "Código",
                    className: "text-left",
                    key: "nsu",
                    sortable: true
                },
                {
                    text: "Descrição",
                    className: "text-left",
                    key: "transaction_description",
                    sortable: false
                },
                {
                    text: "Valor",
                    className: "text-right",
                    key: "transaction_amount",
                    sortable: true
                },
                {
                    text: "Posição saldo",
                    className: "text-right",
                    key: "balance",
                    sortable: true
                }
            ],
            params: {
                sort: "date_brt:desc",
                page: 1,
                ...this.$page.props.queryString
            },
            formPixRollback: this.$inertia.form({
                _method: "POST",
                selectedTransaction: {},
                google_code: null
            }),
            filters: [
                {
                    text: "Período",
                    key: "interval",
                    type: "dropdown",
                    options: [
                        { id: "today", name: "Hoje" },
                        { id: "yesterday", name: "Ontem" },
                        { id: "3_days", name: "Últimos 3 dias" },
                        { id: "7_days", name: "Últimos 7 dias" },
                        { id: "15_days", name: "Últimos 15 dias" },
                        { id: "30_days", name: "Últimos 30 dias" },
                        { id: "this_month", name: "Este mês" },
                        { id: "last_month", name: "Mês passado" }
                    ],
                    colSpan: 2
                },
                {
                    text: "Início",
                    key: "date_from",
                    type: "datepicker",
                    colSpan: 2
                },
                {
                    text: "Término",
                    key: "date_to",
                    type: "datepicker",
                    colSpan: 2
                },
                {
                    text: "Tipo de movimentação",
                    key: "type_movement",
                    type: "dropdown",
                    options: [
                        { id: "C", name: "Crédito" },
                        { id: "D", name: "Débito" }
                    ],
                    colSpan: 2
                },
                {
                    text: 'Categoria de movimentação',
                    key: 'movements',
                    type: 'checkbox_icon',
                    lock: true,
                    colSpan: 4,
                    options: [
                        {id: 'pix', name: 'Pix', img: '../../../images/pix-icone.png',  class: 'w-4'},
                        {id: 'ted', name: 'Ted', icon: 'fas fa-exchange-alt'},
                        {id: 'between_accounts', name: 'Entre contas', img: '/images/Logo cartao.png', class: 'h-2.5'},
                        {id: 'ticket', name: 'Boleto', icon: 'fas fa-receipt'},
                    ]
                }
            ]
        };
    },
    methods: {
        getFormatedId(item) {
            if (Array.isArray(item)) {
                let ids = [];
                item.forEach((element, i) => {
                    let id = element.split("-");
                    ids[i] = id.pop();
                });
                return ids.filter(Boolean).join(" | #");
            } else {
                let id = item.split("-");
                return id.pop();
            }
        },
        downloadExtract: function(type) {
            let endpoint = "/report/extract/download";
            let data = {
                type: type,
                params: JSON.stringify(this.$page.props.queryString),
                logo: this.$page.props.white_label.data.logo_black
            };
            let queryString = Object.keys(data)
                .map(key => key + "=" + data[key])
                .join("&");
            window.location = endpoint + "?" + queryString;
        },
        show: function(item) {
            if (
                item.movement_type === "D" &&
                item.operation_code !== "bank-fee" &&
                item.operation_code !== "maintenance" &&
                item.operation_code !== "acquiring-charge-device"
            ) {
                this.$inertia.get(this.route("receipts.show", item.code));
                return true;
            }
            if (item.original_movement_code && item.movement_type === "D") {
                this.$inertia.get(this.route("receipts.show", item.code));
                return true;
            }
            return false;
        },
        requestPixRollback: function() {
            this.formPixRollback.post("/pix/request-rollback", {
                preserveScroll: true,
                onError: e => {
                    this.formPixRollback.processing = false;
                    this.formPixRollback.google_code = null;
                    this.$forceUpdate();
                },
                onSuccess: () => {
                    this.showRollbackPixModal = false;
                }
            });
        },
        parseDescription: function(item) {
            switch (item.description.split(" ")[0]) {
                case "TED":
                    return "ENVIO TED";
                case "TRANSFERENCIA":
                    return (
                        "ENTRE CONTAS " +
                        (item.movement_type == "D" ? "DÉBITO" : "CRÉDITO")
                    );
                default:
                    return item.description;
            }
        }
    }
};
</script>
